import { useState, useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import swal from '@sweetalert/with-react';
import {
  getClientes,
  getClienteAtual,
  getDadosUsuario,
  isAuthenticated,
  setClientes
} from '../../../shared';
import { nivelUsuarioEnum } from '../../../shared/Enums';
import { getClientesUsuario } from '../../../api/clientes';
import { getConfigAmbiente } from '../../../shared/services/User';

const useUsuarioLogadoHook = ({ setMostraFundoEscuro }) => {
  const history = useHistory();
  const clienteAtual = getClienteAtual();
  const clientes = getClientes();
  const autenticado = isAuthenticated();
  const [mostrarListaClientes, setMostrarListaClientes] = useState(false);
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [novoCliente, setNovoCliente] = useState(null);
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState('');
  const [dadosUserLogado, setDadosUserLogado] = useState(false);
  const theme = useTheme();
  const onlySmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const limitacaoClientesMostra = 500;
  const location = useLocation();
  const [isPending, setPending] = useState(false);
  const [valuePesquisa, setValuePesquisa] = useState('');
  const [controleClienteSelecionado, setControleClienteSelecionado] = useState(false);
  const config = getConfigAmbiente();
  const corSecundariaCliente =
    config && config.cores && config.cores.CORSECUNDARIACLIENTE
      ? config.cores.CORSECUNDARIACLIENTE
      : '#FFFFFF';
  const corBaseCliente =
    config && config.cores && config.cores.CORBASECLIENTE ? config.cores.CORBASECLIENTE : '#333333';

  const abrirListaClientes = () => {
    let tipo = mostrarListaClientes ? false : true;
    setMostraFundoEscuro(tipo);
    setMostrarListaClientes(tipo);
  };

  const searchHandler = term => {
    setValuePesquisa(term);
  };

  const clickBuscarClientes = () => {
    if (dadosUserLogado && dadosUserLogado.nivel !== nivelUsuarioEnum.CLIENTE) {
      buscaClientesUsuario(valuePesquisa);
    } else {
      filtragemClientes(valuePesquisa);
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && valuePesquisa.length > 3) {
      clickBuscarClientes();
    }
  };

  const filtragemClientes = (string, lstClientes = []) => {
    setFilteredClientes([]);
    string = string.toLowerCase();

    let lstFiltragem = [];

    if (lstClientes && lstClientes.length > 0) {
      lstFiltragem = lstClientes;
    } else {
      lstFiltragem = clientes;
    }

    let clientsFiltrados = [
      ...lstFiltragem.filter(cliente => {
        if (
          (cliente.razaoSocial !== null &&
            cliente.id !== 'todos' &&
            cliente.razaoSocial.toLowerCase().includes(string)) ||
          cliente.cnpj.includes(string)
        ) {
          return cliente.razaoSocial.toLowerCase().includes(string) || cliente.cnpj.includes(string);
        }
        return false;
      })
    ];

    let arrayClientes = clientsFiltrados.slice(0, limitacaoClientesMostra);
    setFilteredClientes(arrayClientes);
  };

  const buscaClientesUsuario = string => {
    if ((string && string !== '') || isValidCNPJ(string)) {
      let stringSanitizedToSearch = '';

      const stringNumericaToSearch = isOnlyNumbers(string);

      if (stringNumericaToSearch === true && isValidCNPJ(string)) {
        stringSanitizedToSearch = string.replace(/\D/g, '');
      } else {
        stringSanitizedToSearch = string;
      }

      setPending(true);
      getClientesUsuario(stringSanitizedToSearch)
        .then(retorno => {
          let lstNovosClientes =
            retorno.data && retorno.data.lista_clientes ? retorno.data.lista_clientes : [];
          const listaAtualizada = atualizarLista(clientes, lstNovosClientes, 'cnpj');

          setClientes(listaAtualizada);
          filtragemClientes(stringSanitizedToSearch, listaAtualizada);
        })
        .finally(() => {
          setPending(false);
        });
    }
  };

  const isValidCNPJ = input => {
    const sanitized = input.replace(/\D/g, '');
    return sanitized.length === 14;
  };

  const isOnlyNumbers = input => {
    const sanitized = input.replace(/\D/g, '');
    const regex = /^\d+$/;
    return regex.test(sanitized);
  };

  const atualizarLista = (listaOriginal, novosObjetos, chaveUnica) => {
    let listaAtualizada = [...listaOriginal];
    novosObjetos.forEach(novoObjeto => {
      const objetoExiste = listaOriginal.some(objeto => objeto[chaveUnica] === novoObjeto[chaveUnica]);
      if (!objetoExiste) {
        listaAtualizada.push(novoObjeto);
      }
    });
    return listaAtualizada;
  };

  useEffect(() => {
    pegaNomeUsuario();
    let arrayClientes = clientes ? clientes.slice(0, limitacaoClientesMostra) : [];
    setFilteredClientes(arrayClientes);
  }, []);

  const pegaNomeUsuario = () => {
    let dadosUser = getDadosUsuario();
    let nomeUsuario = dadosUser && dadosUser.nome ? dadosUser.nome : '';
    nomeUsuario =
      nomeUsuario && nomeUsuario !== '' && nomeUsuario !== null && nomeUsuario.includes(' ')
        ? nomeUsuario.split(' ')[0]
        : nomeUsuario;
    setNomeUsuarioLogado(nomeUsuario);
    setDadosUserLogado(dadosUser);
  };

  const trocarEmpresa = cliente => {
    let titulo = 'Trocar para outra empresa';
    if (cliente.id === 'todos') {
      titulo = 'Trocar para todas as empresas';
    }
    swal({
      title: titulo,
      text:
        'Ao confirmar esta ação você será redirecionado para outra sessão. Você quer mesmo continuar?',
      icon: 'warning',
      buttons: ['Cancelar', 'Confirmar'],
      className: 'alert-trocar-empresa'
    }).then(confirm => {
      if (confirm) {
        setNovoCliente(cliente);
      }
    });
  };

  const abrirTela = tela => {
    history.push({
      pathname: `/${tela}`
    });
  };

  useEffect(() => {
    if (clienteAtual && clienteAtual.id !== controleClienteSelecionado) {
      setControleClienteSelecionado(clienteAtual.id);
    }
  }, [clienteAtual]);

  useEffect(() => {
    if (controleClienteSelecionado) {
      window.parent.postMessage(
        {
          condition: clienteAtual && clienteAtual.id !== 'todos',
          type: 'CLIENTE_SELECIONADO',
          payload: clienteAtual
        },
        '*'
      );
    }
  }, [controleClienteSelecionado]);

  return {
    setMostrarListaClientes,
    corSecundariaCliente,
    mostrarListaClientes,
    clickBuscarClientes,
    abrirListaClientes,
    nomeUsuarioLogado,
    filteredClientes,
    dadosUserLogado,
    onlySmallScreen,
    corBaseCliente,
    trocarEmpresa,
    searchHandler,
    handleKeyDown,
    valuePesquisa,
    clienteAtual,
    novoCliente,
    autenticado,
    abrirTela,
    isPending,
    location,
    clientes
  };
};

export default useUsuarioLogadoHook;
